import { useEffect, useRef } from "react";

interface TocEntry {
  text: string;
  index: number;
  isSubTemplate?: boolean;
  isDisabled?: boolean;
  level?: number; // 0 = top-level, 1 = nested under sub-template
}

interface Props {
  entries: TocEntry[];
  activeIndex: number;
  onNavigate: (index: number) => void;
}

export function UnifiedTOC({ activeIndex, entries, onNavigate }: Readonly<Props>) {
  const activeRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    activeRef.current?.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }, [activeIndex]);

  if (entries.length === 0) {
    return null;
  }

  return (
    <div className="unified-toc-container">
      <nav className="unified-toc">
        <div className="unified-toc-header">
          <span className="unified-toc-title">Contents</span>
        </div>
        <ul className="unified-toc-list">
          {entries.map((entry) => (
            <li key={entry.index}>
              <button
                ref={entry.index === activeIndex ? activeRef : null}
                className={`unified-toc-item ${entry.index === activeIndex ? "active" : ""} ${entry.isSubTemplate ? "sub-template" : ""} ${entry.isDisabled ? "disabled" : ""} ${(entry.level ?? 0) > 0 ? "toc-nested" : ""}`}
                onClick={() => {
                  onNavigate(entry.index);
                }}
                title={entry.text}
              >
                {entry.text}
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}
